import React, { useState, useEffect, useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useT } from '../contexts/I18nContext';
import { useAppData } from '../contexts/DataContext';
import { apiFetch } from '../services/api';
import { getChannelsStatus } from '../services/channelsStatus';
import ProfileModal from './ProfileModal';

const NAV_ITEMS = [
  {
    section: 'Продажі',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path fillRule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
      </svg>
    ),
    children: [
      {
        id: 'pos',
        permKey: 'pos_sell',
        label: 'Швидкий продаж',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm2.5 3a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.207.293a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414l6-6a1 1 0 000-1.414zM12.5 10a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'orders',
        permKey: 'orders_view',
        label: 'Відвантаження зі складу',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm0 2h12v2H4V5zm0 4h12v6H4V9z" />
          </svg>
        ),
      },
      {
        id: 'calendar',
        permKey: 'calendar_view',
        label: 'Запис на послуги',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Клієнти',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
      </svg>
    ),
    children: [
      {
        id: 'clients',
        permKey: 'clients_view',
        label: 'Клієнтська база',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
          </svg>
        ),
      },
      {
        id: 'categories',
        label: 'Категорії клієнтів',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        // Договори, згоди, акти з Word, що заповнюються даними (24.10).
        id: 'document_templates',
        permKey: 'documents_templates',
        label: 'Шаблони документів',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h4a1 1 0 100-2H7z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'loyalty',
        permKey: 'loyalty_view',
        label: 'Програми лояльності',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Комунікація',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zm-4 0H9v2h2V9z" clipRule="evenodd" />
      </svg>
    ),
    children: [
      {
        id: 'communication',
        permKey: 'communication_view',
        label: 'Повідомлення',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zm-4 0H9v2h2V9z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        // Лише коли заклад підключив телефонію (23.10) — інакше порожня сторінка.
        id: 'calls',
        permKey: 'clients_view',
        needs: 'telephony',
        label: 'Дзвінки',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
        ),
      },
      {
        id: 'notifications_auto',
        label: 'Авто-повідомлення',
        permKey: 'comm_settings_edit',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Персонал',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
      </svg>
    ),
    children: [
      {
        id: 'staff',
        permKey: 'staff_view',
        label: 'Співробітники',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
          </svg>
        ),
      },
      {
        id: 'schedule',
        label: 'Розклад роботи',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'schedule_templates',
        label: 'Шаблони розкладів',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 6a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2zm0 6a1 1 0 011-1h6a1 1 0 010 2H4a1 1 0 01-1-1z" />
          </svg>
        ),
      },
      {
        id: 'services',
        permKey: 'services_view',
        label: 'Послуги',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M17.707 3.293a1 1 0 010 1.414l-1.586 1.586A7 7 0 115.05 14.95l1.414-1.414a5 5 0 107.072-7.072L12.12 7.88a1 1 0 01-1.414-1.414l1.586-1.586a1 1 0 011.414 0zM4 14a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Склад',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm0 2h12v2H4V5zm0 4h12v6H4V9z" />
      </svg>
    ),
    children: [
      {
        id: 'inventory_products',
        label: 'Номенклатура',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm2 3h8v2H6V6zm0 4h8v2H6v-2z" />
          </svg>
        ),
      },
      {
        id: 'inventory_stock',
        label: 'Залишки',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
          </svg>
        ),
      },
      {
        id: 'inventory_purchases',
        label: 'Закупівлі',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
          </svg>
        ),
      },
      {
        id: 'inventory_movements',
        label: 'Рух товарів',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'production',
        permKey: 'production_view',
        label: 'Виробництво',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M7 2a1 1 0 00-.707 1.707L7 4.414v3.758a1 1 0 01-.293.707l-4 4C.817 14.769 2.156 18 4.828 18h10.344c2.672 0 4.011-3.231 2.122-5.121l-4-4A1 1 0 0113 8.172V4.414l.707-.707A1 1 0 0013 2H7zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187 1.116-1.116A3 3 0 009 8.172z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Зарплати',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
      </svg>
    ),
    children: [
      {
        id: 'salary_calc',
        label: 'Розрахунок',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2H6zm1 2a1 1 0 000 2h6a1 1 0 100-2H7zm6 7a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 2a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm-2-2a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zM7 8a1 1 0 000 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'salary_schemes',
        label: 'Схеми мотивації',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
            <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Фінанси',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
        <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
      </svg>
    ),
    children: [
      {
        id: 'finances',
        permKey: 'finances_view',
        label: 'Фінансові операції',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'cash_register',
        label: 'Каса',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
            <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'tariff_plans',
        label: 'Тарифні плани',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'reports',
        label: 'Звіти',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" />
          </svg>
        ),
      },
      {
        id: 'financial_result',
        label: 'Фін. результат',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Інтеграції',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
      </svg>
    ),
    children: [
      {
        id: 'checkbox_settings',
        label: 'Checkbox ПРРО',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'telegram_settings',
        label: 'Telegram нагадування',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M18.92 2.29a1 1 0 00-1.05-.21L2.37 8.6a1 1 0 00.08 1.89l4.42 1.47 1.47 4.42a1 1 0 001.79.18l2.1-2.8 3.64 2.73a1 1 0 001.55-.6l2.5-12.5a1 1 0 00-.5-1.1zM9.34 12.52l-.87-2.6 6.14-4.1-5.27 6.7z" />
          </svg>
        ),
      },
      {
        id: 'sms_settings',
        label: 'SMS-розсилка',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
        ),
      },
      {
        id: 'email_settings',
        label: 'Email-розсилка',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
          </svg>
        ),
      },
      {
        id: 'nova_poshta_settings',
        label: 'Нова Пошта',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
            <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0h2.1a2.5 2.5 0 014.9 0H17a1 1 0 001-1v-3.5a1 1 0 00-.29-.71l-3-3A1 1 0 0014 7.5h-1V5a1 1 0 00-1-1H3zm10 4.5h1.59L17 10.91V14h-.05a2.5 2.5 0 00-3.9 0V8.5z" />
          </svg>
        ),
      },
      {
        id: 'meest_express_settings',
        label: 'Meest Express',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
            <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0h2.1a2.5 2.5 0 014.9 0H17a1 1 0 001-1v-3.5a1 1 0 00-.29-.71l-3-3A1 1 0 0014 7.5h-1V5a1 1 0 00-1-1H3zm10 4.5h1.59L17 10.91V14h-.05a2.5 2.5 0 00-3.9 0V8.5z" />
          </svg>
        ),
      },
      {
        id: 'rozetka_settings',
        label: 'Rozetka',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'prom_settings',
        label: 'Prom.ua',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 012 2v1a2 2 0 01-2 2v0a2 2 0 01-2 2v.945a6.018 6.018 0 01-6.668-7.918z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'shopify_settings',
        label: 'Shopify',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M6 2a2 2 0 00-2 2v1H3a1 1 0 00-1 1v10a2 2 0 002 2h12a2 2 0 002-2V6a1 1 0 00-1-1h-1V4a2 2 0 00-2-2H6zm8 3H6V4h8v1z" />
          </svg>
        ),
      },
      {
        id: 'olx_settings',
        label: 'OLX',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm4 4a1 1 0 100 2h6a1 1 0 100-2H7zm0 4a1 1 0 100 2h4a1 1 0 100-2H7z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'instagram_settings',
        label: 'Instagram',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M6 2a4 4 0 00-4 4v8a4 4 0 004 4h8a4 4 0 004-4V6a4 4 0 00-4-4H6zm9 3a1 1 0 11-2 0 1 1 0 012 0zm-5 9a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        // Без бренду в назві, на відміну від сусідів: тут інтегруємось не з
        // сервісом, а з довільним сайтом клієнта. Назва — про результат.
        id: 'leads_settings',
        label: 'Заявки з сайту',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.5 2a.75.75 0 000 1.5h9a.75.75 0 000-1.5h-9zm0 3.5a.75.75 0 000 1.5h9a.75.75 0 000-1.5h-9zm0 3.5a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        // Підключення АТС закладу (поки Binotel) — 23.10.
        id: 'telephony_settings',
        label: 'Телефонія',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
          </svg>
        ),
      },
      {
        // Ключі доступу для зовнішніх систем (бот, сайт, телефонія) — 13.10.
        id: 'api_keys',
        label: 'Ключі API',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'messenger_settings',
        label: 'Messenger',
        permKey: 'settings_integrations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M10 2C5.03 2 1 5.73 1 10.32c0 2.61 1.3 4.93 3.34 6.46V19l3.05-1.67c.82.23 1.69.35 2.61.35 4.97 0 9-3.73 9-8.32C19 5.73 14.97 2 10 2zm.9 11.2L8.6 10.74l-4.43 2.46 4.87-5.18 2.36 2.46 4.38-2.46-4.88 5.18z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  },
  {
    section: 'Система',
    icon: (
      <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
        <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
      </svg>
    ),
    children: [
      {
        id: 'users',
        label: 'Користувачі',
        permKey: 'manage_users',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
          </svg>
        ),
      },
      {
        id: 'roles',
        label: 'Ролі',
        permKey: 'manage_roles',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'audit_log',
        label: 'Аудит-лог',
        permKey: 'audit_log_view',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'locations_settings',
        label: 'Локації',
        permKey: 'settings_locations',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'my_plan',
        label: 'Мій план',
        permKey: 'settings_tariffs',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
            <path fillRule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'online_booking_settings',
        label: '',
        permKey: 'settings_booking',
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
          </svg>
        ),
      },
      {
        id: 'help',
        label: '',
        alwaysVisible: true,
        icon: (
          <svg viewBox="0 0 20 20" fill="currentColor" width="15" height="15">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
          </svg>
        ),
      },
    ],
  },
];

// i18n key mapping for sections and nav items
const SECTION_I18N = {
  'Продажі': 'nav.sales',
  'Клієнти': 'nav.clients', 'Комунікація': 'nav.communication',
  'Персонал': 'nav.staff', 'Склад': 'nav.inventory',
  'Зарплати': 'nav.salary', 'Фінанси': 'nav.finances',
  'Інтеграції': 'nav.integrations', 'Система': 'nav.system',
};
const ITEM_I18N = {
  pos: 'nav.pos', orders: 'nav.salesProducts', calendar: 'nav.salesServices',
  clients: 'nav.clientsBase', categories: 'nav.categories', loyalty: 'nav.loyalty',
  communication: 'nav.messages', staff: 'nav.employees',
  schedule: 'nav.schedule', schedule_templates: 'nav.scheduleTemplates',
  services: 'nav.services', tariff_plans: 'nav.tariffPlans',
  inventory_products: 'nav.products', inventory_stock: 'nav.stock',
  inventory_purchases: 'nav.purchases', inventory_movements: 'nav.movements',
  salary_calc: 'nav.salaryCalc', salary_schemes: 'nav.salarySchemes',
  finances: 'nav.financialOps', cash_register: 'nav.cashRegister',
  reports: 'nav.reports', financial_result: 'nav.financialResult',
  users: 'nav.users', roles: 'nav.roles',
  checkbox_settings: 'nav.checkbox', telegram_settings: 'nav.telegram', notifications_auto: 'notifAuto.navItem',
  sms_settings: 'nav.sms', email_settings: 'nav.email',
  nova_poshta_settings: 'nav.novaPoshta',
  meest_express_settings: 'nav.meestExpress',
  olx_settings: 'nav.olx',
  instagram_settings: 'nav.instagram',
  messenger_settings: 'nav.messenger',
  calls: 'nav.calls', telephony_settings: 'nav.telephony', document_templates: 'nav.documentTemplates',
  audit_log: 'nav.auditLog',
  locations_settings: 'nav.locations',
  my_plan: 'nav.myPlan',
  online_booking_settings: 'nav.onlineBooking',
  help: 'nav.help',
};

/**
 * Дзвіночок. Лічильник приходить із bootstrap-core, тобто на старті
 * застосунку зайвих запитів немає — §9 ТЗ. Сам список тягнеться лише
 * тоді, коли дзвіночок відкривають: більшість людей його не чіпає.
 */
/** «5 хв тому» / «вчора 14:20» / «12.09» — дзвіночок без часу читався як
 *  один нескінченний список. */
function agoLabel(ts) {
  if (!ts) return '';
  const diff = Date.now() - ts;
  const min = Math.round(diff / 60000);
  if (min < 1) return 'щойно';
  if (min < 60) return `${min} хв тому`;
  const d = new Date(ts);
  const hhmm = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  if (ts >= today.getTime()) return hhmm;
  if (ts >= today.getTime() - 86400000) return `вчора ${hhmm}`;
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}`;
}

function NotificationBell({ onNavigate, onClose }) {
  const { notificationsUnread, setNotificationsUnread } = useAppData();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    apiFetch('/api/notifications?limit=10')
      .then(r => { setItems(r.items || []); setNotificationsUnread(r.unread || 0); })
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [open, setNotificationsUnread]);

  const markAll = async () => {
    try {
      await apiFetch('/api/notifications', { method: 'POST', body: { all: true } });
      setItems(list => list.map(n => ({ ...n, readAt: n.readAt || Date.now() })));
      setNotificationsUnread(0);
    } catch { /* лічильник підтягнеться наступного відкриття */ }
  };

  const openItem = (n) => {
    setOpen(false);
    if (n.linkView) { onNavigate(n.linkView); onClose(); }
    if (!n.readAt) {
      apiFetch('/api/notifications', { method: 'POST', body: { ids: [n.id] } }).catch(() => {});
      setNotificationsUnread(c => Math.max(0, c - 1));
    }
  };

  return (
    <div className="sidebar-bell-wrap">
      <button className="sidebar-bell" onClick={() => setOpen(v => !v)}>
        <svg width="15" height="15" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
        </svg>
        <span>Сповіщення</span>
        {notificationsUnread > 0 && (
          <span className="nav-item-badge">{notificationsUnread > 99 ? '99+' : notificationsUnread}</span>
        )}
      </button>

      {open && (
        <>
          <div className="bell-backdrop" onClick={() => setOpen(false)} />
          <div className="bell-dropdown">
            <div className="bell-head">
              <span>Сповіщення</span>
              {notificationsUnread > 0 && (
                <button onClick={markAll}>Позначити прочитаними</button>
              )}
            </div>
            {loading && <div className="bell-note">Завантаження…</div>}
            {!loading && !items.length && <div className="bell-note">Поки нічого</div>}
            {items.map(n => (
              <button
                key={n.id}
                className={`bell-item${n.readAt ? '' : ' unread'}`}
                onClick={() => openItem(n)}
              >
                <span className="bell-item-title">
                  {n.title}
                  <span className="bell-item-time">{agoLabel(n.createdAt)}</span>
                </span>
                {n.body && <span className="bell-item-body">{n.body}</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

function Sidebar({ currentView, onNavigate, selectedDate, onDateChange, isOpen, onClose, hasPermission, unreadMsgCount, locations, activeLocationId, onLocationChange, onSearchOpen }) {
  const { userProfile, logout, isSuperAdmin, impersonatedTenantId, setImpersonatedTenantId, availableTenants } = useAuth();
  const { t, lang, setLang, languages: langList } = useT();
  const { planModules, tasksOverdue } = useAppData();
  // Пункти з `needs` показуємо лише коли канал підключено. Кеш статусу
  // спільний і скидається при збереженні налаштувань, тож перечитуємо на
  // кожну навігацію — зайвих запитів це не дає.
  const [channelsOn, setChannelsOn] = useState({});
  const canSeeClients = !hasPermission || hasPermission('clients_view');
  useEffect(() => {
    if (!canSeeClients) return undefined;
    let cancelled = false;
    getChannelsStatus()
      .then(s => { if (!cancelled) setChannelsOn({ telephony: !!s?.telephony?.configured }); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [canSeeClients, currentView]);
  const [profileModal, setProfileModal] = useState(false);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const [locDropdownOpen, setLocDropdownOpen] = useState(false);
  const [expanded, setExpanded] = useState({ 'Продажі': true, 'Комунікація': true, 'Фінанси': true, 'Клієнти': true, 'Персонал': true, 'Склад': true, 'Зарплати': true, 'Система': true });
  const [navYear, setNavYear] = useState(selectedDate.getFullYear());
  const [navMonth, setNavMonth] = useState(selectedDate.getMonth());

  /* Sync calendar display with externally-changed date */
  useEffect(() => {
    setNavYear(selectedDate.getFullYear());
    setNavMonth(selectedDate.getMonth());
  }, [selectedDate]);

  const today = new Date(); today.setHours(0, 0, 0, 0);

  /* Mini calendar helpers */
  const daysInMonth = new Date(navYear, navMonth + 1, 0).getDate();
  const startDow = (new Date(navYear, navMonth, 1).getDay() + 6) % 7; // Mon=0
  const cells = Array(startDow).fill(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const calPrev = () => {
    if (navMonth === 0) { setNavMonth(11); setNavYear(y => y - 1); }
    else setNavMonth(m => m - 1);
  };
  const calNext = () => {
    if (navMonth === 11) { setNavMonth(0); setNavYear(y => y + 1); }
    else setNavMonth(m => m + 1);
  };

  const isSameInNav = (d, date) =>
    date instanceof Date &&
    date.getDate() === d &&
    date.getMonth() === navMonth &&
    date.getFullYear() === navYear;

  const selectDay = (d) => {
    onDateChange(new Date(navYear, navMonth, d));
    onNavigate('calendar');
  };

  const toggleSection = (section) =>
    setExpanded(prev => ({ ...prev, [section]: !prev[section] }));

  return (
    <>
    <div className={`sidebar-overlay${isOpen ? ' visible' : ''}`} onClick={onClose} />
    <aside className={`sidebar${isOpen ? ' open' : ''}`}>
      <div className="sidebar-brand" onClick={() => { onNavigate('dashboard'); onClose(); }} style={{ cursor: 'pointer' }}>
        <div className="sidebar-logo">
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Logo" className="sidebar-logo-img" />
        </div>
        <div className="sidebar-brand-text">
          <img src={`${process.env.PUBLIC_URL}/logo-text.png`} alt="Systemic" className="sidebar-brand-name-img" />
          <span className="sidebar-brand-sub">{t('sidebar.crmSystem')}</span>
        </div>
        <button className="sidebar-close-btn" onClick={e => { e.stopPropagation(); onClose(); }} aria-label="Close menu">✕</button>
      </div>

      {/* ── Search button ── */}
      <button className="sidebar-search-btn" onClick={() => { onSearchOpen?.(); onClose(); }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <span>{t('common.search', 'Пошук')}</span>
      </button>

      <NotificationBell onNavigate={onNavigate} onClose={onClose} />

      <nav className="sidebar-nav">
        {/* ── Location Switcher ── */}
        {locations && locations.length > 1 && (() => {
          const activeLoc = locations.find(l => l.id === activeLocationId) || locations[0];
          return (
            <div className="sidebar-location-switcher">
              <button
                className={`loc-trigger${locDropdownOpen ? ' open' : ''}`}
                onClick={() => setLocDropdownOpen(v => !v)}
              >
                <span className="loc-dot" style={{ background: activeLoc.color }} />
                <span className="loc-name">{activeLoc.name}</span>
                <svg className="loc-chevron" viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
              {locDropdownOpen && (
                <>
                  <div className="loc-dropdown-backdrop" onClick={() => setLocDropdownOpen(false)} />
                  <div className="loc-dropdown">
                    {locations.map(loc => (
                      <button
                        key={loc.id}
                        className={`loc-option${loc.id === activeLocationId ? ' active' : ''}`}
                        onClick={() => { onLocationChange(loc.id); setLocDropdownOpen(false); }}
                      >
                        <span className="loc-dot" style={{ background: loc.color }} />
                        <span className="loc-option-name">{loc.name}</span>
                        {loc.id === activeLocationId && (
                          <svg className="loc-check" viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          );
        })()}

        {/* ── Mini Calendar Widget ── */}
        <div className="sidebar-cal">
          <div className="sidebar-cal-nav">
            <button onClick={calPrev}>‹</button>
            <span className="sidebar-cal-title">{t(`months.${navMonth}`)} {navYear}</span>
            <button onClick={calNext}>›</button>
          </div>

          <div className="sidebar-cal-dow">
            {[0,1,2,3,4,5,6].map(i => <span key={i}>{t(`dow.${i}`)}</span>)}
          </div>

          <div className="sidebar-cal-grid">
            {cells.map((day, i) => {
              if (!day) return <div key={i} className="sc-day empty" />;
              const isToday    = isSameInNav(day, today);
              const isSelected = isSameInNav(day, selectedDate) && currentView === 'calendar';
              return (
                <button
                  key={i}
                  className={`sc-day${isToday ? ' today' : ''}${isSelected ? ' selected' : ''}`}
                  onClick={() => selectDay(day)}
                >
                  {day}
                </button>
              );
            })}
          </div>
        </div>

        {(!hasPermission || hasPermission('business_monitor')) && (
          <div className="nav-group nav-group--standalone">
            <button
              className={`nav-group-header nav-group-clickable ${currentView === 'business_monitor' ? 'active' : ''}`}
              onClick={() => { onNavigate('business_monitor'); onClose(); }}
            >
              <span className="nav-group-icon">
                <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
                  <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                  <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                </svg>
              </span>
              <span className="nav-group-label">{t('nav.businessMonitor')}</span>
              {currentView === 'business_monitor' && <span className="nav-item-dot" />}
            </button>
          </div>
        )}

        {/* «Мій день» був тут окремим пунктом. Тепер це перший блок
            дешборду: два екрани, що конкурують за роль ранкового, завжди
            програють одному. */}
        {(!hasPermission || hasPermission('tasks_view')) && (
          <div className="nav-group nav-group--standalone">
            <button
              className={`nav-group-header nav-group-clickable ${currentView === 'tasks' ? 'active' : ''}`}
              onClick={() => { onNavigate('tasks'); onClose(); }}
            >
              <span className="nav-group-icon">
                <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm7.707 6.293a1 1 0 010 1.414l-3.5 3.5a1 1 0 01-1.414 0l-1.5-1.5a1 1 0 111.414-1.414l.793.793 2.793-2.793a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </span>
              <span className="nav-group-label">{t('nav.tasks', 'Задачі')}</span>
              {/* Overdue count, not open count. A number that only appears
                  when something has actually slipped stays worth looking at;
                  a permanent badge showing "you have work" is noise. */}
              {tasksOverdue > 0 && (
                <span className="nav-item-badge">{tasksOverdue > 99 ? '99+' : tasksOverdue}</span>
              )}
              {currentView === 'tasks' && <span className="nav-item-dot" />}
            </button>
          </div>
        )}

        {/* Проєкти — дошки над задачами. Показуємо всім, хто бачить задачі:
            сторінка сама скаже «вас ще не додали до жодного проєкту». */}
        {(!hasPermission || hasPermission('tasks_view')) && (
          <div className="nav-group nav-group--standalone">
            <button
              className={`nav-group-header nav-group-clickable ${currentView === 'projects' ? 'active' : ''}`}
              onClick={() => { onNavigate('projects'); onClose(); }}
            >
              <span className="nav-group-icon">
                <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
                  <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
                </svg>
              </span>
              <span className="nav-group-label">{t('nav.projects', 'Проєкти')}</span>
              {currentView === 'projects' && <span className="nav-item-dot" />}
            </button>
          </div>
        )}

        <div className="nav-group nav-group--standalone">
          <button
            className={`nav-group-header nav-group-clickable ${currentView === 'dashboard' ? 'active' : ''}`}
            onClick={() => { onNavigate('dashboard'); onClose(); }}
          >
            <span className="nav-group-icon">
              <svg viewBox="0 0 20 20" fill="currentColor" width="18" height="18">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
              </svg>
            </span>
            <span className="nav-group-label">{t('nav.dashboard')}</span>
            {currentView === 'dashboard' && <span className="nav-item-dot" />}
          </button>
        </div>

        {isSuperAdmin && (
          <div className="nav-group nav-group--standalone">
            <button
              className={`nav-group-header nav-group-clickable ${currentView === 'superadmin' ? 'active' : ''}`}
              onClick={() => { onNavigate('superadmin'); onClose(); }}
            >
              <span className="nav-group-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </span>
              <span className="nav-group-label">Адмін-панель</span>
              {currentView === 'superadmin' && <span className="nav-item-dot" />}
            </button>
            {availableTenants.length > 0 && (
              <div style={{ padding: '4px 12px 8px' }}>
                <select
                  value={impersonatedTenantId || ''}
                  onChange={e => setImpersonatedTenantId(e.target.value || null)}
                  style={{
                    width: '100%', padding: '6px 8px', fontSize: '0.8rem',
                    background: '#1e2d3d', color: '#fff',
                    border: '1px solid #3a4f63', borderRadius: 6,
                  }}
                >
                  <option value="" style={{ color: '#8899aa' }}>-- Обрати тенант --</option>
                  {availableTenants.map(t => (
                    <option key={t.id} value={t.id} style={{ background: '#1e2d3d', color: '#fff' }}>{t.businessName || t.name || t.id}</option>
                  ))}
                </select>
                {impersonatedTenantId && (
                  <div style={{ marginTop: 4, fontSize: '0.7rem', color: '#f59e0b', textAlign: 'center' }}>
                    Перегляд тенанта
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {NAV_ITEMS.map(({ section, icon, children, alwaysVisible: groupVisible }) => {
          // planModules: null = not loaded (show all), {} = no config (show all)
          const hasPlanConfig = planModules && Object.keys(planModules).length > 0;
          const visibleChildren = children.filter(item => {
            // "Система" section is always available
            if (section === 'Система') {
              if (item.alwaysVisible || groupVisible) return true;
              const key = item.permKey || item.id;
              return !hasPermission || hasPermission(key);
            }
            // Check plan module access first
            if (hasPlanConfig && planModules[item.id] === false) return false;
            if (item.needs && !channelsOn[item.needs]) return false;
            if (item.alwaysVisible || groupVisible) return true;
            const key = item.permKey || item.id;
            return !hasPermission || hasPermission(key);
          });
          if (visibleChildren.length === 0) return null;

          return (
            <div key={section} className="nav-group">
              <button className="nav-group-header" onClick={() => toggleSection(section)}>
                <span className="nav-group-icon">{icon}</span>
                <span className="nav-group-label">{SECTION_I18N[section] ? t(SECTION_I18N[section]) : section}</span>
                <span className={`nav-chevron ${expanded[section] ? 'open' : ''}`}>
                  <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </button>
              {expanded[section] && (
                <div className="nav-children">
                  {visibleChildren.map(item => (
                    <button
                      key={item.id}
                      className={`nav-item ${currentView === item.id ? 'active' : ''}`}
                      onClick={() => onNavigate(item.id)}
                    >
                      <span className="nav-item-icon">{item.icon}</span>
                      <span className="nav-item-label">{ITEM_I18N[item.id] ? t(ITEM_I18N[item.id]) : item.label}</span>
                      {item.id === 'communication' && unreadMsgCount > 0 && (
                        <span className="nav-item-badge">{unreadMsgCount > 99 ? '99+' : unreadMsgCount}</span>
                      )}
                      {currentView === item.id && <span className="nav-item-dot" />}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        {userProfile && (
          <div className="sidebar-user-info">
            <div className="sidebar-lang-icon" title={t('common.language')}>
              <button className="lang-icon-btn" onClick={() => setLangDropdownOpen(v => !v)}>
                {langList.find(l => l.code === lang)?.flag}
              </button>
              {langDropdownOpen && (
                <>
                  <div className="lang-dropdown-backdrop" onClick={() => setLangDropdownOpen(false)} />
                  <div className="lang-dropdown">
                    {langList.map(l => (
                      <button
                        key={l.code}
                        className={`lang-option${l.code === lang ? ' active' : ''}`}
                        onClick={() => { setLang(l.code); setLangDropdownOpen(false); }}
                      >
                        <span className="lang-option-flag">{l.flag}</span>
                        <span className="lang-option-name">{l.name}</span>
                        {l.code === lang && (
                          <svg className="lang-check" viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        )}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="sidebar-user-avatar" onClick={() => setProfileModal(true)} title={t('common.profile')}>
              {(userProfile.displayName || '?').charAt(0).toUpperCase()}
            </div>
            <div className="sidebar-user-details" onClick={() => setProfileModal(true)} style={{ cursor: 'pointer' }}>
              <span className="sidebar-user-name">{userProfile.displayName}</span>
              <span className="sidebar-user-email">{userProfile.email}</span>
            </div>
            <button className="sidebar-logout-btn" onClick={logout} title={t('common.logout')}>
              <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                <path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        )}
        <div className="sidebar-version">{t('sidebar.version')}</div>
      </div>
    </aside>
    {profileModal && <ProfileModal onClose={() => setProfileModal(false)} hasPermission={hasPermission} />}
    </>
  );
}

export default Sidebar;
